import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getProducts, removeProduct, activeProduct } from '../../../actions/productsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Products() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {products, loading, result} = useSelector(state=>state.products) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getProducts())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])  

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('products.itsok'),
                    icon: 'error',
                    text: t('products.'+result.message+'0') + result.count + t('products.'+result.message+'1')
                })
                dispatch({
                    type: 'PRODUCT_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('products.letsok'),
                    icon: 'success',
                    text: t('products.deletedproduct')
                })
                dispatch({
                    type: 'PRODUCT_RESET_RESULT'
                })
            }
        }
    }, [result, dispatch, t])

    const deleteProduct = (idProduct) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeProduct(idProduct))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    const handleActive = (e, idProduct) => {
        dispatch(activeProduct(idProduct, e.target.checked))
    }

    // Datatables
    const columns = [
        {
            name: t('products.active'),
            cell: datos =>
                <div className='form-check checkbox-lg'>
                    <input className="form-check-input" id="active_product" type='checkbox' onChange={(e) => handleActive(e, datos._id)} checked={datos.active} />
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('products.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('products.matter'),
            cell: datos =>
                <div>
                    {datos.matter}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/product/`+datos._id}>
                    <i className="fas fa-spray-can"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteProduct(datos._id)}>
                    <i className="fas fa-spray-can"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('products.editproduct')}</h1> 
                        <label className='mb-2'>{t('products.selectproduct')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/product`}>
                                <i className="fas fa-spray-can"></i> {t('products.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {products 
                                ?
                                    <CustomDataTable columns={columns} data={products} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}